import type {
  AdaptiveScanningPhase,
  AdaptiveScanningStateDto,
} from '@terra/shared-contracts-applications';
import type { BlockedReasonType } from '@terra/shared-schemas-orchestrator';
import type { OperationStatusBadgeState } from './OperationStatusBadge';

export type HomeScanningStatus =
  | { kind: 'paused'; reason: BlockedReasonType | null }
  | { kind: 'adaptive'; phase: AdaptiveScanningPhase }
  | { kind: 'automation'; enabled: boolean };

export const resolveHomeScanningStatus = ({
  adaptiveState,
  executionsEnabled,
}: {
  adaptiveState:
    | Pick<AdaptiveScanningStateDto, 'enabled' | 'phase' | 'pausedReason'>
    | null
    | undefined;
  executionsEnabled: boolean;
}): HomeScanningStatus => {
  if (adaptiveState?.enabled && adaptiveState.phase) {
    return adaptiveState.phase === 'paused_blocked'
      ? { kind: 'paused', reason: adaptiveState.pausedReason ?? null }
      : { kind: 'adaptive', phase: adaptiveState.phase };
  }

  return { kind: 'automation', enabled: executionsEnabled };
};

export const toScanningBadgeState = (
  status: HomeScanningStatus,
): OperationStatusBadgeState => {
  if (status.kind === 'paused') {
    return 'paused';
  }

  if (status.kind === 'adaptive') {
    return 'active';
  }

  return status.enabled ? 'active' : 'inactive';
};
